import React, { Component } from 'react'
import styled from 'styled-components'

import IcWinner from './images/ic-winner.component.svg'
import IcAdd from './images/ic-add.component.svg'
import IcSee from 'components/MyTarifSectionV2/images/ic-see.component.svg'

import WhatsappIcon from 'components/MyTarifSectionV2/images/ic-whatsapp.component.svg'
import FacebookIcon from 'components/MyTarifSectionV2/images/ic-facebook.component.svg'
import XIcon from 'components/MyTarifSectionV2/images/ic-x.component.svg'
import MailIcon from 'components/MyTarifSectionV2/images/ic-mail.component.svg'

import DropdownGhostV2 from '../DropdownGhostV2'
import ShareButtonV2 from '../ShareButtonV2'
import InlineCheckV2 from '../InlineCheckV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import { generateMediaUrl } from 'utils'

export default class ResultTarifMobileV2 extends Component {
  state = {
    shareUrl: `${window.location.origin}${window.location.pathname}?code=${this.simulationCode}`,
    shareContent: 'Veja a minha simulação em',
  }

  renderTag = (text, icon) => {
    return (
      <span className='tag'>
        {icon}
        <p>{text}</p>
      </span>
    )
  }

  /** Lonely boy */
  render() {
    const {
      bestAnnualBilling,
      setCompare,
      compareList,
      index,
      toggleJoinModal,
      toggleDetailsModal,
      result,
    } = this.props

    // Calculate money saved
    const moneySaved = bestAnnualBilling - result.annualBilling

    // Calculate subscriptions
    let subscriptions
    let medalText
    let icon
    let title

    // Get values depending if electricity or gas
    if (result.electricityPriceList) {
      subscriptions = result.electricityPriceList.subscriptions
      icon = result.electricityPriceList.entity.hi_res_logo
      title = result.electricityPriceList.designation
    }

    if (result.gasPriceList) {
      subscriptions = result.gasPriceList.subscriptions
      icon = result.gasPriceList.entity.hi_res_logo
      title = result.gasPriceList.designation
    }

    if (subscriptions.count >= 50) {
      medalText = `+50 ${subscriptions.period}`
    } else if (subscriptions.count >= 20) {
      medalText = `+20 ${subscriptions.period}`
    } else if (subscriptions.count >= 5) {
      medalText = `+5 ${subscriptions.period}`
    }

    const moreInfoParams = {
      ...this.props,
      moneySaved,
      priceListId: result.id,
    }

    if (result.electricityPriceList) {
      moreInfoParams.id = result.electricityPriceList.id
      title = `${title} (${
        result.priceListTimeCycle === 's'
          ? 'Simples'
          : result.priceListTimeCycle === 'b'
          ? 'Bi-Horário'
          : 'Tri-Horário'
      })`
    } else if (result.gasPriceList) {
      moreInfoParams.id = result.gasPriceList.id
    }

    const savingsDesignation =
      Math.abs(Math.round(moneySaved)) === 0
        ? 'Idêntico ao atual'
        : moneySaved <= 0
        ? 'Sobrecusto'
        : 'Poupança'

    return (
      <Wrapper>
        <Header>
          <img src={generateMediaUrl(icon)} alt={title} />
          <TitleRow>
            <h2>{title}</h2>
            <span className='tagsWrapper'>
              {index === 0 && this.renderTag('Mais Económico', <IcWinner />)}
              {medalText && this.renderTag(medalText, <IcWinner />)}
            </span>
          </TitleRow>

          <ShareWrapper>
            <DropdownGhostV2 titleArea={<ShareButtonV2 />}>
              <div style={{ width: '186px', border: '1px solid #ECECEC' }}>
                <ShareBtn
                  href={`https://wa.me/?text=${encodeURIComponent(
                    this.state.shareContent
                  )} ${encodeURIComponent(this.state.shareUrl)}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <WhatsappIcon />
                  <p>Whatsapp</p>
                </ShareBtn>
                <ShareBtn
                  href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                    this.state.shareUrl
                  )}&quote=${encodeURIComponent(this.state.shareContent)}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <FacebookIcon />
                  <p>Facebook</p>
                </ShareBtn>
                <ShareBtn
                  href={`https://twitter.com/intent/tweet/?text=${encodeURIComponent(
                    this.state.shareContent
                  )}&url=${encodeURIComponent(this.state.shareUrl)}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <XIcon />
                  <p>X</p>
                </ShareBtn>
                <ShareBtn
                  noBorder
                  href={`mailto:?subject=${encodeURIComponent(
                    'Simulação'
                  )}&body=${encodeURIComponent(
                    `${this.state.shareContent} ${this.state.shareUrl}`
                  )}`}
                  target='_blank'
                  rel='noopener'
                  aria-label=''>
                  <MailIcon />
                  <p>Mail</p>
                </ShareBtn>
              </div>
            </DropdownGhostV2>
          </ShareWrapper>
        </Header>
        <Savings isMoneySaved={moneySaved}>
          <p>{savingsDesignation}</p>

          {moneySaved && Math.abs(Math.round(moneySaved)) < 0 ? (
            <h4>+{Math.abs(Math.round(moneySaved))} €/ano</h4>
          ) : null}
          {moneySaved && Math.abs(Math.round(moneySaved)) > 0 ? (
            <h4>{Math.abs(Math.round(moneySaved))} €/ano</h4>
          ) : null}
        </Savings>
        <Footer>
          <InputWrapper>
            <InlineCheckV2
              noBackground
              style={{ width: '100%' }}
              onClick={() => setCompare(result)}
              name='Comparar'
              disabled={
                compareList.length === 2 &&
                !compareList.some((item) => item.id === result.id)
              }
              selected={compareList.some((item) => item.id === result.id)}
            />
          </InputWrapper>
          <BtnsWrapper>
            <ButtonOutlineV2
              style={{ width: '48px', height: '48px' }}
              onClick={() => toggleDetailsModal(moreInfoParams)}
              setModalTriggerHeight={this.props.setModalTriggerHeight}
              icon={<IcSee />}
            />
            <ButtonGradientV2
              setModalTriggerHeight={this.props.setModalTriggerHeight}
              style={{ width: '120px', height: '48px' }}
              onClick={() => toggleJoinModal(moreInfoParams)}
              icon={<IcAdd />}>
              Aderir
            </ButtonGradientV2>
          </BtnsWrapper>
        </Footer>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
  width: 100%;
`

const Header = styled.div`
  display: flex;
  padding: 8px 20px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-bottom: 1px solid #ececec;

  > img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`

const Savings = styled.div`
  display: flex;
  height: 48px;
  padding: 12px 20px;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  align-self: stretch;
  background: rgba(147, 193, 62, 0.2);

  ${({ isMoneySaved }) =>
    isMoneySaved < 0 &&
    `
    background: linear-gradient(0deg, rgba(192, 0, 0, 0.10) 0%, rgba(192, 0, 0, 0.10) 100%), #FFF;
  `}

  ${({ isMoneySaved }) =>
    isMoneySaved === 0 &&
    `
    background: linear-gradient(0deg, rgba(117, 117, 117, 0.10) 0%, rgba(117, 117, 117, 0.10) 100%), #FFF;
  `}

  > p {
    color: #006736;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
  }

  > h4 {
    color: #006736;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 1px;
    margin: 0;
    text-transform: unset !important;
  }
`

const TitleRow = styled.div`
  display: flex;
  padding: 6px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;

  > h2 {
    overflow: hidden;
    color: #1d1e22;
    text-overflow: ellipsis;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    align-self: stretch;
    margin: 0 !important;
    text-align: unset !important;
    text-transform: unset !important;
  }

  .tagsWrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .tag {
    display: flex;
    align-items: center;
    gap: 4px;
    align-self: stretch;

    > p {
      overflow: hidden;
      color: #006736;
      text-overflow: ellipsis;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 14px;
      flex: 1 0 0;
      margin: 0;
    }
  }
`

const ShareBtn = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  height: 40px;
  padding: 10px;
  border-bottom: ${({ noBorder }) => (noBorder ? 'none' : '1px solid #ECECEC')};
  background: #fff;
  text-decoration: none;

  cursor: pointer;

  p {
    flex: 1 0 0;
    color: #3e3e3e;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
`

const ShareWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`

const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-top: 1px solid #ececec;

  @media screen and (min-width: 500px) {
    padding-inline: 16px;
  }
`

const BtnsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media screen and (min-width: 500px) {
    gap: 12px;
  }
`

const InputWrapper = styled.div`
  width: 120px;

  @media screen and (min-width: 500px) {
    width: 156px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ResultTarifMobileV2/index.js